/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import IconButton from "@mui/material/IconButton";
import MDBox from "dashboard-template/components/MDBox";
import { useMaterialUIController, setSidenavColor } from "context/ThemeContext";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentUser } from "store/slices/auth.slice";
import { authAction } from "store/store";
import useHttp from "hooks/http.hook";
import { CoreAPI_URLs } from "constants/http.const";
import { UserInterface, HeaderEnum } from "@malmur-technologies/medicalsystem-shared";

type SidenavColorType = "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark";

const SideNavarColor = () => {
  const [controller, themeDispatch] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const currentUser = useSelector(selectCurrentUser);
  const reduxDispatch = useDispatch();
  const [_isLoading, _error, sendRequest] = useHttp();
  
  const sidenavColors: SidenavColorType[] = ["primary", "dark", "info", "success", "warning", "error"];

  /**
   * Handles sidebar color change and saves to user profile in backend
   * @param color - Selected sidebar color
   */
  const handleColorChange = async (color: SidenavColorType) => {
    // Update UI immediately
    setSidenavColor(themeDispatch, color);
    
    // Save to backend if user is logged in
    if (currentUser?.id) {
      const updatedProfile = {
        ...(currentUser.profile || {}),
        sidenavColor: color,
      };

      const updatedUser: UserInterface = {
        ...currentUser,
       profile: updatedProfile,
      };

      try {
        await sendRequest<UserInterface>(
          CoreAPI_URLs.USERS_GENERAL_OPERATIONS,
          (response) => {
            if (response) {
              reduxDispatch(authAction.storeUser(response));
            }
          },
          "PUT",
          JSON.stringify(updatedUser),
          [{ header: HeaderEnum.USER_ID, value: currentUser.id }]
        );
      } catch (error) {
        console.error('Error saving sidenav color preference:', error);
      }
    }
  };

  return (
    <MDBox mb={0.5}>
      {sidenavColors.map((color, index) => (
        <IconButton
          key={color}
          onClick={() => handleColorChange(color)}
          className={`sidenav-button ${darkMode ? "dark-mode" : "light-mode"} ${
            sidenavColor === color ? "selected" : ""
          } ${["one", "two", "three", "four", "five", "six"][index]}`}
        />
      ))}
    </MDBox>
  );
};

export default SideNavarColor;
